import React, {memo, useCallback} from 'react';
import {PasswordContainer} from '../../../../components/PasswordContainer';
import {SettingsPageContainer} from '../../../../components/Settings/SettingsPageContainer';
import {RangeComponent} from '../../../../components/Range/RangeComponent';
import iconSound from '../../../../assets/images/icons/settings/sound.png';
import iconSoundOff from '../../../../assets/images/icons/settings/soundoff.png';
import microphoneOn from '../../../../assets/images/icons/settings/microphoneon.png';
import microphoneOff from '../../../../assets/images/icons/settings/microphoneoff.png';

import './index.scss';
import {useDispatch, useSelector} from 'react-redux';
import {SoundState} from '../../../../store/control/state';
import {useRPC} from '../../../../hooks/rpc';
import {setSoundStateAction} from '../../../../store/control/actions';
import {useMessage} from '../../../../hooks/message';
import {useLocalization} from "../../../../hooks/localization";

export const SoundEditScreen = memo(function SoundEditScreen() {
    const {t} = useLocalization();
    const [rpc] = useRPC();
    const dispatch = useDispatch();
    const {failure} = useMessage();
    const sound = useSelector(state => state.control.sound);

    const onChange = useCallback((newSound: SoundState) => {
        rpc.updateSoundState(newSound)
            .then(() => dispatch(setSoundStateAction(newSound)))
            .catch(failure);
    }, [dispatch, failure, rpc]);

    const onIntercomChange = useCallback((value: number) => {
        onChange({...sound, intercom_level: value});
    }, [onChange, sound]);

    const onAlarmChange = useCallback((value: number) => {
        onChange({...sound, alarm_level: value});
    }, [onChange, sound]);

    const onIncomingCallFlatFrontChange = useCallback((value: number) => {
        onChange({...sound, incoming_call_flat_front_level: value});
    }, [onChange, sound]);

    const onIncomingCallOutsidePanelChange = useCallback((value: number) => {
        onChange({...sound, incoming_call_outside_panel_level: value});
    }, [onChange, sound]);

    const onMicrophoneLevelChange = useCallback((value: number) => {
        onChange({...sound, microphone_level: value});
    }, [onChange, sound]);

    return (
        <PasswordContainer requiredRole="default" isFullscreen={true}>
            <SettingsPageContainer
                buttons={[]}
                className='service-edit'
                backUrl={'/settings'}>
                <div className='content-divider'>
                    <div className='content-wrapper'>
                        <RangeComponent
                            columnProps={{min: 12}}
                            name={t('intercom_call_voice')}
                            value={sound.intercom_level}
                            onChange={onIntercomChange}
                            activeImage={iconSound}
                            passiveImage={iconSoundOff}/>
                        <RangeComponent
                            columnProps={{min: 12}}
                            name={t('alarm_ring_volume')}
                            value={sound.alarm_level}
                            onChange={onAlarmChange}
                            activeImage={iconSound}
                            passiveImage={iconSoundOff}/>
                        <RangeComponent
                            columnProps={{min: 12}}
                            name={t('microphone_level')}
                            value={sound.microphone_level}
                            onChange={onMicrophoneLevelChange}
                            activeImage={microphoneOn}
                            passiveImage={microphoneOff}/>
                    </div>
                    <div className='content-wrapper'>
                        <RangeComponent
                            columnProps={{min: 12}}
                            name={t('incoming_call_outer_panel')}
                            value={sound.incoming_call_outside_panel_level}
                            onChange={onIncomingCallOutsidePanelChange}
                            activeImage={iconSound}
                            passiveImage={iconSoundOff}/>
                        <RangeComponent
                            columnProps={{min: 12}}
                            name={t('incoming_call_flat_front')}
                            value={sound.incoming_call_flat_front_level}
                            onChange={onIncomingCallFlatFrontChange}
                            activeImage={iconSound}
                            passiveImage={iconSoundOff}/>
                    </div>
                </div>
            </SettingsPageContainer>
        </PasswordContainer>
    );
});
